import React from 'react'
import { useState } from 'react';

function ChartSlider({cards, startChart, setChartSliderShow}) {
  const [current, setCurrent] = useState(startChart);
  const handleNext = e => setCurrent((current + 1) % cards.length);
  const handlePrev = e => {
    if(current > 0)
      setCurrent(current - 1);
    else 
      setCurrent(cards.length - 1);
  }
  return (
    <div className="ChartSlider" onClick={e => {setChartSliderShow(false);}}>
      <div className="Content" onClick={ e => {e.stopPropagation();} }>
        <div>
        <div className="valign-wrapper">
        <div className="slide-key">{current+1}</div>
        <div>
        <h4 className="title">{cards[current].title}</h4>
        <div className="description">{cards[current].description}</div>
        <div className="chart-title">{cards[current].chartTitle}</div>
        </div>
        </div>
        <img src={cards[current].slideImage} alt={`chart${current}`}/>
        </div>
        <div className="pager">{current+1} of {cards.length}</div>
        <div className="next" onClick={handleNext}><i class="mck-arrow-right-icon"/></div>
        <div className="prev" onClick={handlePrev}><i class="mck-arrow-left-icon"/></div>
        <div className="close" onClick={e => setChartSliderShow(false)}><span class="mck-close-icon"></span></div>
      </div>
    </div>
  )
}


function Card({card, index, setCurrentChart, setChartSliderShow}) {
  const handleCardClick = (card,index) => (e) => {
    setCurrentChart(index);
    setChartSliderShow(true);
  }

  return (
    <div className="card"  key={index} onClick={handleCardClick(card, index)}>
      <img src={card.cardImage} alt={index}/>
    </div>
  );

}

function Grid (props) {
  const [currentChart, setCurrentChart] = useState(null);
  const [chartSliderShow, setChartSliderShow] = useState(false);
  return (
    <div className="App">
      <h2 className="title">12 highlights from McKinsey Global <br/>Institute 2021 research</h2>
      <div className="info">Click each card to learn more</div>
      <div className="cards">
      {props.cards.map((card, index) => 
        <Card key={index} card={card} index={index} setCurrentChart={setCurrentChart} setChartSliderShow={setChartSliderShow}/>
      )}
      </div>
      {
        chartSliderShow && <ChartSlider cards={props.cards} startChart={currentChart} setChartSliderShow={setChartSliderShow} />
      }
    </div>
  );

}

export default Grid;
